// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__32zdy","footer":"ModalFilter_footer__1KeQV"};